import React, { useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import axiosInstance from '../utils/axiosConfig';
import * as CustomToast from '../components/CustomToastMessage';


function Profile({ formData, setFormData }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);
    const [editableFirstName, setEditableFirstName] = useState(formData.firstName);
    const [editableLastName, setEditableLastName] = useState(formData.lastName);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL}/api/auth/user/edit`, {
                firstName: editableFirstName,
                lastName: editableLastName,
                email: formData.email,
            })
            if (response.status === 200) {
                CustomToast.success(response.data.message)
                setFormData({
                    ...formData,
                    firstName: editableFirstName,
                    lastName: editableLastName,
                });
                handleClose()
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
        }
        finally {
            setLoading(false)
        }
    }


    return (
        <>

            <Dropdown.Item onClick={handleShow}>
                <img src="/images/png/user.png" width={24} alt="" />
                My Profile
            </Dropdown.Item>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter First Name"
                                    id="firstName"
                                    name="firstName"
                                    value={editableFirstName}
                                    onChange={(e) => setEditableFirstName(e.target.value)}

                                />
                            </Form.Group>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Last Name"
                                    id="lastName"
                                    name="lastName"
                                    value={editableLastName}
                                    onChange={(e) => setEditableLastName(e.target.value)}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter Email"
                                    id="email"
                                    name="email"
                                    disabled
                                    value={formData.email}
                                />
                            </Form.Group>
                        </div>


                    </div>
                    <div className='d-flex justify-content-center gap-3 mt-3'>
                        <button className='btn-primary px-5' onClick={handleSubmit} disabled={loading}>Save</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Profile